// export const foo = 'foo';
import TaskListNew from './TaskListNew';

export default TaskListNew;
